import styled from "styled-components";
import NewUserCarousel from "./NewUserCarousel";
import useCreateProfileMutation from "../../lib/useCreateProfileMutation";
import CreateProfileForm from "./CreateProfileForm";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import dayjs from "dayjs";
import { Spacer } from "../../styles/CommonElements";
import { ModalTitle } from "../CustomModal";

export default function CreateProfile() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const {
    mutate: createProfile,
    isPending: isRegistering,
    isSuccess: isProfileCreated,
  } = useCreateProfileMutation();

  const onSubmit = async (data) => {
    const birthDate = dayjs(data.birthDate);

    const profileData = {
      ...data,
      id: user.uid,
      email: user.email,
      birthDate,
    };

    try {
      await createProfile(profileData);
      navigate("/use");
    } catch (error) {
      console.error("Error creating profile:", error);
    }
  };

  return (
    <>
      {!isProfileCreated ? (
        <Container>
          <InnerContainer>
            <ModalTitle>Tell us about yourself</ModalTitle>
            <Spacer $marginTop="0.25rem" />
            <Subtitle>This helps us optimize your experience</Subtitle>
            <Spacer $marginTop="1rem" />
            <InnerInnerContainer>
              <CreateProfileForm
                onSubmit={onSubmit}
                isSubmitting={isRegistering}
              />
            </InnerInnerContainer>
          </InnerContainer>
        </Container>
      ) : (
        <NewUserCarousel />
      )}
    </>
  );
}

const Container = styled.div`
  width: 90%;
  margin: auto;
  margin-top: 3rem;
  position: relative;
`;

const InnerContainer = styled.div`
  width: 100%;
  margin: auto;
  position: relative;
  display: block;
  z-index: 5;
`;

const InnerInnerContainer = styled.div`
  text-align: left;
`;

const Header = styled.div`
  color: var(--color-cream);
  text-align: center;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: #000;
  font-family: var(--font-primary);
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 48px */
`;

const Subtitle = styled.p`
  color: var(--color-gray-100);
  text-align: center;
  font-family: var(--font-primary);
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.75rem;
  margin: 0;
`;
